import { createAction } from 'redux-act';

export const registerNetworkLoungeUser = createAction('Registerd Network Lounge');
export const removeUserFromNetworkLounge = createAction('remove user from network lounge');
export const addNetworkingLoungeUserPresenceData = createAction<any>('get lounge user presence data');
